<template>
  <v-card
    class="job-card d-flex flex-column"
    outlined
    hover
    @click="onOpen"
  >
    <div class="job-card__media">
      <v-img
        :src="imageSrc"
        height="168"
        contain
        eager
        @error="onImageError"
      ></v-img>
    </div>

    <div class="job-card__body d-flex flex-column flex-grow-1">
      <h3 class="job-card__title">{{ displayTitle }}</h3>

      <hr v-if="hasExplanation" class="job-card__divider job-card__divider--short" />

      <div class="job-card__explain-slot">
        <p v-if="hasExplanation" class="job-card__explain">
          {{ job.explanation }}
        </p>
      </div>

      <hr v-if="companyLabel" class="job-card__divider" />

      <div v-if="companyLabel" class="job-card__meta">
        <span>
          <v-icon x-small color="#64748b">mdi-domain</v-icon>
          {{ companyLabel }}
        </span>
      </div>

      <v-btn
        block
        depressed
        :outlined="outlined"
        color="primary"
        class="job-card__cta"
        @click.stop="onOpen"
      >
        {{ actionLabel }}
        <v-icon right small>mdi-arrow-right</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "JobCard",
  props: {
    job: { type: Object, required: true },
    to: { type: String, default: "" },
    actionLabel: { type: String, default: "View job" },
    outlined: { type: Boolean, default: false },
    blank: { type: Boolean, default: false },
  },
  data: () => ({
    imageFailed: false,
  }),
  computed: {
    imageSrc() {
      const file =
        this.imageFailed || !(this.job && this.job.image)
          ? "default.jpg"
          : this.job.image
      return process.env.VUE_APP_API_ENDPOINT + "images/jobs/" + file
    },
    displayTitle() {
      const title = (this.job && this.job.name) || ""
      if (!title) return ""
      return title.charAt(0).toUpperCase() + title.slice(1)
    },
    companyLabel() {
      return (this.job && this.job.full_name) || ""
    },
    hasExplanation() {
      return !!(this.job && this.job.explanation)
    },
  },
  methods: {
    onImageError() {
      this.imageFailed = true
    },
    onOpen() {
      if (!this.to) return
      if (this.blank) {
        const resolved = this.$router.resolve(this.to)
        window.open(resolved.href, "_blank", "noopener")
        return
      }
      this.$router.push(this.to)
    },
  },
}
</script>

<style scoped>
.job-card {
  flex: 1 1 auto;
  width: 100%;
  height: 100% !important;
  border-radius: 16px !important;
  border-color: #e8edf3 !important;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06) !important;
  overflow: hidden;
  cursor: pointer;
}
.job-card__media {
  position: relative;
  z-index: 0;
  flex-shrink: 0;
  background: #f1f5f9;
}
.job-card__body {
  position: relative;
  z-index: 1;
  padding: 16px 16px 14px;
  background: #fff;
  box-shadow: 0 -6px 12px rgba(15, 23, 42, 0.12);
}
.job-card__title {
  flex-shrink: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  color: #0f172a;
  margin: 0 0 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.job-card__explain-slot {
  flex: 1 1 auto;
  min-height: 0;
}
.job-card__explain {
  font-size: 12.5px;
  line-height: 1.35;
  color: #64748b;
  font-style: italic;
  margin: 0;
}
.job-card__divider {
  flex-shrink: 0;
  border: 0;
  border-top: 1px solid #e8edf3;
  margin: 12px 0;
}
.job-card__divider--short {
  width: 32px;
  margin-left: auto;
  margin-right: auto;
}
.job-card__meta {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  color: #64748b;
  font-size: 13px;
}
.job-card__meta span {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.job-card__cta {
  flex-shrink: 0;
  margin-top: auto !important;
  text-transform: none !important;
  letter-spacing: 0;
  font-weight: 600;
  border-radius: 10px !important;
  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
}
</style>
